import { render, staticRenderFns } from "./feature1.vue?vue&type=template&id=51517d30&scoped=true"
import script from "./feature1.vue?vue&type=script&lang=js"
export * from "./feature1.vue?vue&type=script&lang=js"
import style0 from "./feature1.vue?vue&type=style&index=0&id=51517d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-load_5a3c64a85473ede7d9205802ebc6db0e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51517d30",
  null
  
)

export default component.exports